import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';

import {
  Button
} from 'components/common';

import 'bootstrap/dist/css/bootstrap.css';

interface ICasaModal {
  heading: string;
  visible: boolean;
  actionLabel?: string;
  cancelLabel?: string;
  toggle: (isVisible: boolean) => void;
  action: () => void;
  footer?: React.ReactNode;
  style?: React.CSSProperties;
}

const CasaModal: React.FC<ICasaModal> = ({ visible, heading, actionLabel, cancelLabel, toggle, action, footer, children, ...attributeOptions }) => (
  <Modal
    isOpen={visible}
    toggle={() => toggle(!visible)}
    modalTransition={{ timeout: 700 }}
    fade={false}
    scrollable={true}
    {...attributeOptions}>
    <ModalHeader toggle={() => toggle(!visible)}>{heading}</ModalHeader>
    <ModalBody>
      {children}
    </ModalBody>
    <ModalFooter className='justify-content-start'>
      {
        footer ??
        <>
          <Button as='secondary' onClick={action} >{actionLabel ?? 'Yes'}</Button>
          <Button as='primary' onClick={() => toggle(!visible)}>{cancelLabel ?? 'No'}</Button>
        </>
      }
    </ModalFooter>
  </Modal>
);

export default CasaModal;